// Cream Cocoa — Theme JS

// Sticky header shadow on scroll
const header = document.getElementById('SiteHeader');
if (header) {
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 20);
  }, { passive: true });
}

// Duplicate sensory strip for seamless marquee
const track = document.getElementById('sensoryTrack');
if (track) {
  const clone = track.cloneNode(true);
  clone.setAttribute('aria-hidden', 'true');
  track.parentNode.appendChild(clone);
}

// Smooth fade-in on scroll
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1';
      entry.target.style.transform = 'translateY(0)';
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.1 });

document.querySelectorAll('.diff-cell, .note-card, .product-card, .recipe-card, .o-stat').forEach(el => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(16px)';
  el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
  observer.observe(el);
});
